import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { TrackingSearchService } from './tracking-search.service';
import { TrackingService } from '../tracking.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class TrackingSearchResolve implements Resolve<any> {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private _TrackingSearchService: TrackingSearchService,
    private _Router: Router
  ) {}

  http: Observable<any>;
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      if (route.queryParams['track']) {
        return this._TrackingSearchService
          .GetConsignmentListInfo(
            route.queryParams['track']
              .split(',')
              .filter((v, i, a) => a.indexOf(v) === i)
          )
          .pipe(retry(1));
      } else {
        this._Router.navigate[''];
        return of(false);
      }
    }
    return null;
  }
}

export class TrackingSearchVerifyPhoneResolve implements Resolve<any> {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private _TrackingSearchService: TrackingSearchService,
    private _Router: Router
  ) {}

  http: Observable<any>;
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      if (route.queryParams['track']) {
        return this._TrackingSearchService
          .GetConsignmentListInfoฺVerifyPhone(
            route.queryParams['track']
              .split(',')
              .filter((v, i, a) => a.indexOf(v) === i)
          )
          .pipe(retry(1));
      } else {
        this._Router.navigate[''];
        return of(false);
      }
    }
    return null;
  }
}
